
import { Component, Vue } from "vue-property-decorator";
import NewsMultipleTemplate from "@/template/multiple/NewsMultiple.vue";
@Component
export default class NewsMultiple extends NewsMultipleTemplate {}
